import { Pipe, PipeTransform } from '@angular/core';
import { FormService } from '../../core/services/v2/form.service';

@Pipe({
  name: 'getPatientDataOption'
})
export class GetPatientDataOptionPipe implements PipeTransform {
  constructor(private _formService: FormService) {}
  transform(value: any): string {
    if (!value) return '';

    var result;
    this._formService.getPatientInformationItemOptionsAll().subscribe((items) => {
      result = items ? items.filter((obj) => obj.patientInfo === value && obj.friendlyName) : result;
    },
      (error) => { console.error(error); });

    return result && result.length > 0 ? result[0].friendlyName : value;
  }

}
